export const indicators = {
  gdhi: "Moniteur de santé numérique mondial",
  indicatorGuide: "Guide des indicateurs",
  paragraph1:
    "<a class='link-blue' href='http://digitalhealthindex.org' target='_blank'>Moniteur de santé numérique mondial (GDHM)</a>" +
    " est une ressource numérique interactive qui suit, surveille et évalue l'utilisation de la technologie numérique pour la santé dans tous " +
    "les pays. Le GDHM utilise sept catégories d'indicateurs clés pour suivre les progrès.",
  indicator: "l'indicateur",
  selected_indicator: "indicateur sélectionné",
};
